import React from 'react';
import NavbarNavLink from '@theme-original/NavbarItem/NavbarNavLink';
import useDocusaurusContext from '@docusaurus/useDocusaurusContext';
import {useLocation} from '@docusaurus/router';
import useIsBrowser from '@docusaurus/useIsBrowser';
import {getPricingRegisterHref} from '@site/src/components/FreeTools/shared/freeToolLinks';

export default function AttributedNavbarNavLink(props) {
    const {siteConfig} = useDocusaurusContext();
    const frontendUrl = siteConfig.customFields.frontendUrl;
    const location = useLocation();
    const isBrowser = useIsBrowser();
    const defaultRegisterHref = `${frontendUrl}/register`;
    const registerHref = isBrowser ? getPricingRegisterHref(frontendUrl, location) : defaultRegisterHref;

    return <NavbarNavLink {...props}
                          to={props.to === defaultRegisterHref ? registerHref : props.to}
                          href={props.href === defaultRegisterHref ? registerHref : props.href}/>;
}
